import { gql } from '@apollo/client';

export const REMOVE_OFFICER_FROM_INCIDENT = gql`
  mutation removeOfficerFromIncident($input: RemoveOfficerFromIncidentInput!) {
    removeOfficerFromIncident(input: $input) {
      clientMutationId
      errors
    }
  }
`

//Example input:
// {
//   "input": {
//    "officerIncidentSpecificId": 1423,
//    "officerId": 1997,
//    "originatorId": 1234,
//    "clientMutationId": 1111,
//   }
// }

